const dataLimitType = ["unlimited", "capped"] as const;
const dataLimitTypeFullName = ["Unlimited", "Capped"] as const;
const accType = [
  "carrier",
  "msp",
  "sdWan",
  "si",
  "reseller",
  "agent",
  "others",
] as const;
const accTypeFullName = [
  "Carrier",
  "MSP",
  "SD-WAN",
  "SI",
  "Reseller",
  "Agent",
  "Others",
] as const;
const apiIntegrationStatus = ["live", "inactive", "errorStage"] as const;
const apiIntegrationsStatusFullName = [
  "Live",
  "Inactive",
  "Error Stage",
] as const;
const apiStatus = ["active", "inactive", "notAvailable"] as const;
const apiStatusFullName = ["Active", "Inactive", "Not Available"] as const;
const biaAccessTech = [
  "ADSL",
  "VDSL",
  "SDSL",
  "GPON",
  "Coax",
  "Cable",
  "Copper",
  "Ethernet",
  "FTTC",
  "FTTH",
  "FTTP",
  "Fiber",
] as const;
const biaInterfaceType = ["RJ45", "LC", "SC", "ST"] as const;
const biaIpType = [
  "DYNAMIC_IP",
  "FIXED_IP",
  "IP_32",
  "IP_31",
  "IP_30",
  "IP_29",
  "IP_28",
  "IP_27",
] as const;
const biaIpTypeFullName = [
  "1 Dynamic IP",
  "1 Fixed IP",
  "/32",
  "/31",
  "/30",
  "/29",
  "/28",
  "/27",
] as const;
const companyType = ["customer", "vendor", "airx"] as const;
const contractTermsOptions = [
  {
    value: "1",
    label: "1 month",
  },
  {
    value: "3",
    label: "3 months",
  },
  {
    value: "6",
    label: "6 months",
  },
  {
    value: "12",
    label: "12 months",
  },
  {
    value: "24",
    label: "24 months",
  },
  {
    value: "36",
    label: "36 months",
  },
  {
    value: "48",
    label: "48 months",
  },
  {
    value: "60",
    label: "60 months",
  },
] as const;

const currency = [
  "AED",
  "AFN",
  "ALL",
  "AMD",
  "ANG",
  "AOA",
  "ARS",
  "AUD",
  "AWG",
  "AZN",
  "BAM",
  "BBD",
  "BDT",
  "BGN",
  "BHD",
  "BIF",
  "BMD",
  "BND",
  "BOB",
  "BRL",
  "BSD",
  "BTN",
  "BWP",
  "BYN",
  "BZD",
  "CAD",
  "CDF",
  "CHF",
  "CLP",
  "CNY",
  "COP",
  "CRC",
  "CUP",
  "CVE",
  "CZK",
  "DJF",
  "DKK",
  "DOP",
  "DZD",
  "EGP",
  "ERN",
  "ETB",
  "EUR",
  "FJD",
  "FKP",
  "FOK",
  "GBP",
  "GEL",
  "GGP",
  "GHS",
  "GIP",
  "GMD",
  "GNF",
  "GTQ",
  "GYD",
  "HKD",
  "HNL",
  "HRK",
  "HTG",
  "HUF",
  "IDR",
  "ILS",
  "IMP",
  "INR",
  "IQD",
  "IRR",
  "ISK",
  "JEP",
  "JMD",
  "JOD",
  "JPY",
  "KES",
  "KGS",
  "KHR",
  "KID",
  "KMF",
  "KRW",
  "KWD",
  "KYD",
  "KZT",
  "LAK",
  "LBP",
  "LKR",
  "LRD",
  "LSL",
  "LYD",
  "MAD",
  "MDL",
  "MGA",
  "MKD",
  "MMK",
  "MNT",
  "MOP",
  "MRU",
  "MUR",
  "MVR",
  "MWK",
  "MXN",
  "MYR",
  "MZN",
  "NAD",
  "NGN",
  "NIO",
  "NOK",
  "NPR",
  "NZD",
  "OMR",
  "PAB",
  "PEN",
  "PGK",
  "PHP",
  "PKR",
  "PLN",
  "PYG",
  "QAR",
  "RON",
  "RSD",
  "RUB",
  "RWF",
  "SAR",
  "SBD",
  "SCR",
  "SDG",
  "SEK",
  "SGD",
  "SHP",
  "SLE",
  "SOS",
  "SRD",
  "SSP",
  "STN",
  "SYP",
  "SZL",
  "THB",
  "TJS",
  "TMT",
  "TND",
  "TOP",
  "TRY",
  "TTD",
  "TVD",
  "TWD",
  "TZS",
  "UAH",
  "UGX",
  "USD",
  "UYU",
  "UZS",
  "VES",
  "VND",
  "VUV",
  "WST",
  "XAF",
  "XCD",
  "XDR",
  "XOF",
  "XPF",
  "YER",
  "ZAR",
  "ZMW",
  "ZWL",
] as const;
const dcCrossConnectType = ["copper", "fiber"] as const;
const dcCrossConnectTypeFullName = ["Copper", "Fiber"] as const;
const diaAccessTechFullName = [
  "Copper",
  "Ethernet",
  "Fiber",
  "Radio",
  "Microwave",
] as const;
const diaAccessTech = [
  "Copper",
  "Ethernet",
  "Fiber",
  "Radio",
  "Microwave",
] as const;
const diaInterfaceTech = ["RJ45", "LC", "SC", "ST"] as const;
const documentsStatusVariants = [
  "active",
  "inactive",
  "updated",
  "expired",
  "terminated",
] as const;
const documentsSubTypeVariants = [
  "NDA",
  "MSA",
  "SLA",
  "T_AND_C",
  "OTHER",
] as const;
const documentsVariants = ["agreement", "product", "other"] as const;
const eplAccessTech = ["Ethernet", "Fiber"] as const;
const escalationLevel = [
  "level1",
  "level2",
  "level3",
  "level4",
  "level5",
] as const;
const fieldHoursType = ["BH", "OOBH", "PH"] as const;
const fieldHoursTypeFullName = [
  "Business Hours",
  "Out of Business Hours",
  "Weekend/Public Holidays",
] as const;
const fieldServiceTypeFullName = [
  "Best Effort",
  "SLA (4H)",
  "SLA (8H)",
  "SLA (NBD)",
] as const;
const fieldServiceType = ["Best_Effort", "SLA_4H", "SLA_8H", "SLA_NBD"];
const includedType = ["Included", "Excluded"] as const;
const includedTypeFullName = ["Included", "Excluded"] as const;
const locationType = [
  "enterprise",
  "airport",
  "data_center",
  "embassy",
  "industrial",
  "government",
  "shopping",
  "hotels",
  "healthcare",
  "education",
  "telecom",
  "media",
  "financial",
  "entertainment",
  "others",
] as const;
const locationTypeFullName = [
  "Enterprise Building",
  "Airport",
  "Data Center",
  "Embassy",
  "Industrial Facility",
  "Government Site",
  "Shopping and Retail Center",
  "Hotel and Hospitality",
  "Healthcare Facility",
  "Education Institution",
  "Telecom Hub and Exchange",
  "Media and Broadcast Center",
  "Financial Institution",
  "Entertainment and Sports Venue",
  "Others",
] as const;
const maintenanceType = ["OEM", "THIRD_PARTY"] as const;
const maintenanceTypeFullName = ["OEM", "3rd Party"] as const;
const maintenanceSlaType = [
  "SLA_24x7x4",
  "SLA_24x7x8",
  "SLA_24x5x4",
  "SLA_24x5x8",
  "SLA_8x5x4",
  "NBD",
] as const;

const maintenanceSlaTypeFullName = [
  "24x7x4",
  "24x7x8",
  "24x5x4",
  "24x5x8",
  "8x5x4",
  "NBD",
] as const;
const networkType = ["On_net", "Near_net", "Off_net"] as const;
const networkTypeFullName = ["On-net", "Near-net", "Off-net"] as const;
const purchaseType = ["Resale", "Rental"] as const;
const QUOTES_TYPE = [
  "DIA",
  "IPT",
  "BIA",
  "WIA",
  "ipAddress",
  "EPL",
  "DWDM",
  "networkingHardwareServices",
  "fieldServices",
  "dcServiceRockAndSpace",
  "dcServiceCrossContent",
] as const;
const quotesTypeFullName = [
  "DIA",
  "IPT",
  "BIA",
  "WIA",
  "IP Address",
  "EPL ",
  "DWDM",
  "Hardware",
  "Field Services",
  "DC Service - Rack & Space",
  "DC Service - Cross Connect",
] as const;
const rackSizeFullName = [
  "RU",
  "Quarter Rack",
  "Half Rack",
  "Full Rack",
] as const;
const rackSize = ["RU", "QUARTER_RACK", "HALF_RACK", "FULL_RACK"] as const;
const ROLE = ["admin", "standard"] as const;
const roleFullName = ["Admin", "Standard"] as const;
const sourceOfPrice = ["manual", "BuildingList", "CountryCoverage"] as const;
const statusAccount = ["active", "inactive", "pending", "suspended"] as const;
const statusAccountFullName = [
  "Active",
  "Inactive",
  "Pending",
  "Suspended",
] as const;
const wiaAccessTech = [
  "G4",
  "G5",
  "Satellite",
  "Wireless",
  "Radio",
  "Microwave",
] as const;
const wiaAccessTechFullName = [
  "4G",
  "5G",
  "Satellite",
  "Wireless",
  "Radio",
  "Microwave",
] as const;

type IncludedType = (typeof includedType)[number];
export {
  wiaAccessTechFullName,
  wiaAccessTech,
  statusAccountFullName,
  statusAccount,
  sourceOfPrice,
  roleFullName,
  ROLE,
  rackSize,
  rackSizeFullName,
  quotesTypeFullName,
  QUOTES_TYPE,
  purchaseType,
  networkTypeFullName,
  networkType,
  maintenanceSlaTypeFullName,
  maintenanceSlaType,
  maintenanceTypeFullName,
  maintenanceType,
  locationTypeFullName,
  locationType,
  includedTypeFullName,
  fieldServiceType,
  fieldServiceTypeFullName,
  fieldHoursTypeFullName,
  fieldHoursType,
  escalationLevel,
  eplAccessTech,
  documentsVariants,
  documentsSubTypeVariants,
  documentsStatusVariants,
  diaInterfaceTech,
  diaAccessTech,
  diaAccessTechFullName,
  dcCrossConnectTypeFullName,
  dcCrossConnectType,
  currency,
  contractTermsOptions,
  companyType,
  biaIpTypeFullName,
  biaIpType,
  biaInterfaceType,
  biaAccessTech,
  apiStatusFullName,
  apiStatus,
  apiIntegrationsStatusFullName,
  apiIntegrationStatus,
  accTypeFullName,
  accType,
  dataLimitTypeFullName,
  dataLimitType,
  includedType,
};
export type { IncludedType };
